var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { class: ["ui-checkbutton", { checked: _vm.value }] }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.computedValue,
          expression: "computedValue"
        }
      ],
      attrs: { type: "checkbox" },
      domProps: {
        checked: Array.isArray(_vm.computedValue)
          ? _vm._i(_vm.computedValue, null) > -1
          : _vm.computedValue
      },
      on: {
        change: function($event) {
          var $$a = _vm.computedValue,
            $$el = $event.target,
            $$c = $$el.checked ? true : false
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v)
            if ($$el.checked) {
              $$i < 0 && (_vm.computedValue = $$a.concat([$$v]))
            } else {
              $$i > -1 &&
                (_vm.computedValue = $$a
                  .slice(0, $$i)
                  .concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.computedValue = $$c
          }
        }
      }
    }),
    _vm.$slots.icon
      ? _c("div", { staticClass: "ui-checkbutton-icon" }, [_vm._t("icon")], 2)
      : _vm._e(),
    _c("span", [_vm._v(_vm._s(_vm.label))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }